export default __webpack_public_path__ + "locales/sl/ArchiveDialog.json?hash=59b64a460b63da20ada4522e0f9c69e8";